<template>
  <div class="grid gap-6 lg:grid-cols-3">
    <section class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm lg:col-span-2">
      <h2 class="text-lg font-semibold text-ink">This week</h2>
      <div class="mt-4 grid gap-4 sm:grid-cols-3">
        <div class="rounded-2xl border border-orange-100 bg-[#FFF7EF] p-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-muted">New leads</p>
          <p class="mt-3 text-2xl font-semibold text-ink">18</p>
          <p class="text-xs text-muted">+6 vs last week</p>
        </div>
        <div class="rounded-2xl border border-gray-100 bg-white p-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-muted">Proposals</p>
          <p class="mt-3 text-2xl font-semibold text-ink">12</p>
          <p class="text-xs text-muted">4 awaiting approval</p>
        </div>
        <div class="rounded-2xl border border-gray-100 bg-white p-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-muted">Bookings</p>
          <p class="mt-3 text-2xl font-semibold text-ink">5</p>
          <p class="text-xs text-muted">$42k projected</p>
        </div>
      </div>

      <div class="mt-6 rounded-2xl border border-gray-100 bg-white p-5">
        <div class="flex items-center justify-between">
          <p class="text-sm font-semibold text-ink">Upcoming walkthroughs</p>
          <button class="text-xs font-semibold text-brand">View all</button>
        </div>
        <div class="mt-4 grid gap-3">
          <div class="flex items-center justify-between rounded-xl border border-gray-100 px-4 py-3 text-sm">
            <div>
              <p class="font-semibold text-ink">Terrace Garden</p>
              <p class="text-xs text-muted">June 18 · 2:00 PM</p>
            </div>
            <span class="rounded-full bg-[#FFF3E5] px-3 py-1 text-xs font-semibold text-ink">On-site</span>
          </div>
          <div class="flex items-center justify-between rounded-xl border border-gray-100 px-4 py-3 text-sm">
            <div>
              <p class="font-semibold text-ink">Cedar Loft</p>
              <p class="text-xs text-muted">June 20 · 11:00 AM</p>
            </div>
            <span class="rounded-full bg-[#FFF3E5] px-3 py-1 text-xs font-semibold text-ink">Virtual</span>
          </div>
        </div>
      </div>
    </section>

    <section class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
      <h2 class="text-lg font-semibold text-ink">Quick actions</h2>
      <div class="mt-4 space-y-3 text-sm">
        <button class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-left font-semibold text-ink transition hover:border-brand hover:text-brand">
          Create new venue listing
        </button>
        <button class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-left font-semibold text-ink transition hover:border-brand hover:text-brand">
          Draft a package offer
        </button>
        <button class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-left font-semibold text-ink transition hover:border-brand hover:text-brand">
          Review pending contracts
        </button>
      </div>

      <div class="mt-6 rounded-2xl border border-orange-100 bg-[#FFF7EF] p-4 text-sm">
        <p class="font-semibold text-ink">Upcoming payout</p>
        <p class="mt-2 text-xs text-muted">Next deposit scheduled for June 28.</p>
        <p class="mt-3 text-lg font-semibold text-ink">$8,420</p>
      </div>
    </section>
  </div>
</template>
